import TUIPayments from './components/index'

customElements.define('tui-payments', TUIPayments)
